import { PurebrandLineChart } from 'components/Chart/LineChart';
import React, { useEffect, useState } from 'react';
import { getBadgeTimeseries } from 'Services/badgeAnalyticsService';

const SERIES_COLORS = {
  impressions: 'rgb(50, 157, 215)',
  clicks: 'rgb(36, 188, 183)',
  joins: 'rgb(255, 99, 132)',
};

const buildChartData = (rows) => {
  const labels = rows.map((r) => r.date);
  return {
    labels,
    datasets: [
      {
        label: 'Impressions',
        data: rows.map((r) => r.impressions ?? 0),
        fill: false,
        borderColor: SERIES_COLORS.impressions,
        backgroundColor: `${SERIES_COLORS.impressions.replace('rgb', 'rgba').replace(')', ', 0.3)')}`,
      },
      {
        label: 'Clicks',
        data: rows.map((r) => r.clicks ?? 0),
        fill: false,
        borderColor: SERIES_COLORS.clicks,
        backgroundColor: `${SERIES_COLORS.clicks.replace('rgb', 'rgba').replace(')', ', 0.3)')}`,
      },
      {
        label: 'Joins',
        data: rows.map((r) => r.joins ?? 0),
        fill: false,
        borderColor: SERIES_COLORS.joins,
        backgroundColor: `${SERIES_COLORS.joins.replace('rgb', 'rgba').replace(')', ', 0.3)')}`,
      },
    ],
  };
};

const BadgeTimeSeriesChart = ({ storeId, range }) => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!storeId) return;
    setLoading(true);
    getBadgeTimeseries({ storeId, range })
      .then((res) => {
        const rows = res?.data?.data || res?.data || [];
        if (Array.isArray(rows) && rows.length > 0) {
          setChartData(buildChartData(rows));
        } else {
          setChartData(null);
        }
      })
      .catch((err) => {
        console.error('BadgeTimeSeriesChart fetch error:', err);
        setChartData(null);
      })
      .finally(() => setLoading(false));
  }, [storeId, range]);

  if (loading) {
    return (
      <div
        style={{
          height: 200,
          background: '#f5f5f5',
          borderRadius: 8,
          marginTop: 16,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#aaa',
        }}
      >
        Loading chart...
      </div>
    );
  }

  if (!chartData) {
    return (
      <div className="alert alert-light mt-3" role="alert">
        No time-series data for this period.
      </div>
    );
  }

  return (
    <div className="column-wrapper p-3 mt-3">
      <p className="chart-main-title">
        Badge Impressions / Clicks / Joins — Daily
      </p>
      <PurebrandLineChart data={chartData} />
    </div>
  );
};

export default BadgeTimeSeriesChart;
